<button>
  <div class="left-container flex-c-c">
    <current-sked-task-progress [task]="task" [diameter]="83" [strokeWidth]="6">
      <div class="icon-container flex-c-c">
        <img [src]="'assets/img/icons/color-icons/' + task.icon + '.svg'" class="task-icon" />
      </div>
    </current-sked-task-progress>
    <span class="complete-tasks">{{ percentCompleteDisplay }}</span>
  </div>
  <div class="right-container">
    <div class="text-container">
      <span class="active-task-title"> ACTIVE TASK </span>
      <span class="task-label">{{ task.label }}</span>
    </div>
    <div class="bottom-container">
      <div class="bottom-container-item project" [style.background]="project?.color || 'transparent'">
        {{ project?.label || 'Unknown' }}
      </div>
      <div class="bottom-container-item duration">{{ task?.duration | minutesToHoursAndMinutes }}</div>
    </div>
  </div>
</button>
